/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const savings_account_in = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1 9.556h4.667M4.11 11.11l1.556-1.555m0 0L4.11 8m.552 6.547c.083.27.329.453.606.453h1.443a.64.64 0 0 0 .624-.524l.073-.819a.64.64 0 0 1 .625-.524H9.13a.64.64 0 0 1 .625.525l.108.818a.64.64 0 0 0 .624.524h1.495a.638.638 0 0 0 .594-.415l.803-2.641a.646.646 0 0 1 .136-.214c.833-.879 1.33-1.936 1.33-3.147 0-2.865-2.608-5.25-6.045-5.25-1.23 0-2.554.298-3.52.81a2.807 2.807 0 0 0-2.207-.135.653.653 0 0 0-.369.889l.321.7m4.82-3.664a.933.933 0 1 1 1.867 0M6.911 6h3.267"
    />
  </svg>
)
export default savings_account_in
